<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ assistant.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AssistantTabLinks />
                    <!--div class="flex mt-2">
            <ProductFinder
              business_type="assistant"
              :business_id=$route.params.id
              @select="selectAssistantService"
            />
          </div-->
                    <div class="flex mt-2">
                        <CButton color="primary" @click="create"> Создать </CButton>
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th><input v-model="areTableItemsDraggable" type="checkbox" /></th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th></th>
                            </thead>
                            <component
                                :is="areTableItemsDraggable ? 'draggable': 'tbody'"
                                v-model="serviceList"
                                tag="tbody">
                                <tr v-for="service in serviceList" :key="service.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="cursor-pointer"
                                        />
                                    </td>
                                    <td>
                                        <CLink
                                            :to="`/assistants/${assistant.id}/service/${service.id}`"
                                        >{{ service.title }}</CLink
                                        >
                                    </td>
                                    <td>
                                        <p>{{ service.price }}</p>
                                    </td>
                                    <td>
                                        <input
                                            v-model="service.enabled"
                                            type="checkbox"
                                            @change="updateService(service)"
                                        />
                                    </td>
                                </tr>
                            </component>
                        </table>
                        <CPagination
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="totalPages"
                            align="center"
                        />
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save"
                    >Сохранить порядок</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';

    import AssistantTabLinks from '@/components/assistant/AssistantTabLinks';
    import ProductFinder from '@/components/ProductFinder';
    import { ITEMS_PER_PAGE } from '../../utils/views';

    export default {
        name: 'AssistantServiceList',

        components: {
            AssistantTabLinks,
            draggable,
            ProductFinder,
        },

        data() {
            return {
                assistant: {},
                serviceList: [],
                totalPages: 0,
                areTableItemsDraggable: true
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            this.fetchEntity();
            this.fetchList();
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            async fetchList() {
                const id = this.$route.params.id;
                const params = { page: this.activePage };
                Vue.axios
                    .get('/assistants/' + id + '/services', { params })
                    .then(resp => {
                        this.serviceList = resp.data.results;
                        this.totalPages = parseInt(resp.data.total / ITEMS_PER_PAGE) + 1;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            async fetchEntity() {
                const id = this.$route.params.id;
                Vue.axios
                    .get('/assistants/' + id)
                    .then(resp => {
                        this.assistant = resp.data;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.serviceList.forEach(service => {
                    reorder.push({
                        id: service.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post('/assistants/' + this.assistant.id + '/services/reorder', {
                        reorder: reorder,
                    })
                    .then(resp => {
                        this.$router.push('/assistants/' + this.assistant.id);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения порядка товаров.');
                    });
            },

            create() {
                this.$router.push('/assistants/' + this.assistant.id + '/service/create');
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            selectAssistantService(id) {
                this.$router.push('/assistants/' + this.assistant.id + '/service/' + id);
            },
            updateService(service) {
                Vue.axios.put('/assistants/' + this.assistant.id + '/services/' + service.id, service)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохраниения.');
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: 0 .2rem;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
</style>
